/* eslint-disable react/display-name */
import React, { PureComponent, memo } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Button from './Button';

// Form value pickup
// component: 'button-multi'
// name: data-name
// value: data-value
// Have to convert numeric value from string manually

const styles = (theme) => ({
  root: {
    flexDirection: 'row',
    '& .MuiFormControlLabel-root': {
      margin: 0,
    },
    '& .MuiFormControlLabel-root button': {
      borderRadius: 0,
    },
    '& .MuiFormControlLabel-root:first-child button': {
      borderTopLeftRadius: 4,
      borderBottomLeftRadius: 4,
    },
    '& .MuiFormControlLabel-root:last-child button': {
      borderTopRightRadius: 4,
      borderBottomRightRadius: 4,
    },
    '& .MuiFormControlLabel-root button svg': {
      marginRight: theme.spacing(1),
    },

    '& button.Mui-disabled': {
      '&:hover': {
        backgroundColor: 'var(--color-backgroundColors-disabled)',
        color: '#929292',
      },
      '&:focus': {
        backgroundColor: 'var(--color-backgroundColors-disabled)',
        color: '#929292',
      },
    },
  },
});

const FormControlLabelMemo = memo((props) => <FormControlLabel {...props} />);

const StyledButton = memo(
  ({ option, value, buttonColors, onChange, disabled }) => (
    <FormControlLabelMemo
      value={option.value}
      control={
        <Button
          variant="contained"
          color={option.value === value ? buttonColors[0] : buttonColors[1]}
          onClick={onChange}
          disabled={disabled}
          className={`button-toggle button-toggle--${
            option.value === value ? buttonColors[0] : buttonColors[1]
          }`}
        >
          {option.icon ? option.icon : null}
          {option.label}
        </Button>
      }
    />
  )
);

class ButtonMulti extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      dataValue: this.props.value,
    };

    this.onClickModifier = this.onClickModifier.bind(this);
  }

  onClickModifier(event, value, onChange) {
    event.preventDefault();

    this.setState({
      dataValue: value,
    });

    onChange(value);
  }

  render() {
    const {
      options,
      value,
      classes,
      buttonColors,
      onChange,
      name,
      disabled,
      ...restProps
    } = this.props;
    return (
      <div
        className={classes.root}
        {...restProps}
        data-name={name}
        data-component="button-toggle"
        data-value={this.state.dataValue}
      >
        {options.map((option) => (
          <StyledButton
            key={option.value}
            option={option}
            value={value}
            buttonColors={buttonColors}
            onChange={(e) => this.onClickModifier(e, option.value, onChange)}
            disabled={disabled}
          />
        ))}
      </div>
    );
  }
}

ButtonMulti.defaultProps = {
  buttonColors: ['primary', 'white'],
  name: '',
  disabled: false,
};

ButtonMulti.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  buttonColors: PropTypes.arrayOf(PropTypes.string),
  disabled: PropTypes.bool,
};

export default withStyles(styles)(ButtonMulti);
